import { render, staticRenderFns } from "./ModalDeleteAccount.vue?vue&type=template&id=4fa93bae&scoped=true&"
import script from "./ModalDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteAccount.vue?vue&type=style&index=0&id=4fa93bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa93bae",
  null
  
)

export default component.exports